var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"version-badge",attrs:{"aria-hidden":"true"}},[_c('div',[_c('span',{staticClass:"label"},[_vm._v("panel")]),_vm._v(_vm._s(_vm.panel))]),_c('div',[_c('span',{staticClass:"label"},[_vm._v("api")]),_vm._v(_vm._s(_vm.api))])])
}
var staticRenderFns = []

export { render, staticRenderFns }